<template>
  <div class="flow-common-data-approval">
    <template v-if="dataView">
      <DataPanelV v-bind="dataView"></DataPanelV>
    </template>
    <template v-else>
      <Hint type="empty">
        <div>流程审批数据为空</div>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataPanelV from '../../../../../elements/datav/DataPanelV'
import Hint from '../../../../../elements/Hint'
export default {
  name: 'FlowCommonDataApproval',
  components: {
    DataPanelV,
    Hint
  },
  props: {
    dataView: Object
  }
}
</script>

<style lang="scss">
.flow-common-data-approval {
  .layout-hint {
    height: 160px;
  }
}
</style>
